/** 视频生成中转：POST `/v1/video/generations` → agiBack（localhost:8000）再转发至 Seedance */
export const VIDEO_GENERATION_BASE_URL =
  process.env.REACT_APP_AGI_BACK_URL || '/proxy/agiBack';

/** 视频任务状态查询、虚拟人像等：直连 AI 网关（ai.k23.cn） */
export const VIDEO_GENERATION_UPSTREAM_BASE_URL =
  process.env.REACT_APP_BASE_URL || '/proxy/base';

/** 文生图（Gemini / OpenAI Images）→ cl8n-ai，开发经 `/proxy/international` 转发 */
export const IMAGE_GEN_BASE_URL =
  process.env.REACT_APP_IMAGE_GEN_URL || '/proxy/international';

/** 生图专用 API Key（cl8n-ai），不读取用户配置的 Token */
export const IMAGE_GEN_API_KEY =
  'sk-Y3wvzN1ZZSai3GRv9QYn2SoyD5uNPjhgC03vgkz2Mbd2UYKc';

/** 生图（Gemini / OpenAI Images）单次请求最长等待时间 */
export const IMAGE_GENERATION_TIMEOUT_MS = 10 * 60 * 1000;

export const VIRTUAL_PORTRAIT_PROJECT = 'cqsy';

/** virtual_portrait 接口资产组类型：虚拟人像 AIGC，真人素材 LivenessFace */
export const PORTRAIT_GROUP_TYPE_AIGC = 'AIGC';
export const PORTRAIT_GROUP_TYPE_LIVENESS_FACE = 'LivenessFace';
export type PortraitGroupType =
  | typeof PORTRAIT_GROUP_TYPE_AIGC
  | typeof PORTRAIT_GROUP_TYPE_LIVENESS_FACE;

/** 与接口文档 POST 上传人像素材示例一致，须为 `Image`（勿用小写 image）。 */
export const VP_ASSET_TYPE_IMAGE = 'Image';
export const VP_ASSET_TYPE_VIDEO = 'Video';
export const VP_ASSET_TYPE_AUDIO = 'Audio';

/** 工作台各类型激活上限 */
export const WORKSPACE_MAX_ACTIVE_IMAGES = 9;
export const WORKSPACE_MAX_ACTIVE_VIDEOS = 3;
export const WORKSPACE_MAX_ACTIVE_AUDIOS = 3;
export const WORKSPACE_MAX_PROMPTS = 9;

export interface WorkspaceMaterialLimits {
  images: number;
  videos: number;
  audios: number;
}

/** 默认模型沿用工作台现有上限；模型有特殊能力时只在这里声明差异。 */
export const WORKSPACE_DEFAULT_MATERIAL_LIMITS: WorkspaceMaterialLimits = {
  images: WORKSPACE_MAX_ACTIVE_IMAGES,
  videos: WORKSPACE_MAX_ACTIVE_VIDEOS,
  audios: WORKSPACE_MAX_ACTIVE_AUDIOS,
};

export const WORKSPACE_MODEL_MATERIAL_LIMITS: Record<string, WorkspaceMaterialLimits> = {
  'doubao-seedance-2-5-260628': {
    images: 30,
    videos: 10,
    audios: 10,
  },
};

export const getWorkspaceMaterialLimits = (model: string): WorkspaceMaterialLimits =>
  WORKSPACE_MODEL_MATERIAL_LIMITS[model] || WORKSPACE_DEFAULT_MATERIAL_LIMITS;

/** 素材库分页默认上限（首屏/下拉条数由视口动态计算，见 libraryPortraitPaging） */
export const LIBRARY_PORTRAIT_LIST_PAGE_SIZE = 24;

/** 生成视频时：关闭字幕 → 提示词前缀 */
export const SUBTITLE_PROMPT_FORBID = '严禁出现字幕';
/** 生成视频时：开启字幕 → 提示词前缀 */
export const SUBTITLE_PROMPT_NEED = '需要字幕';

/** 按字幕开关在用户提示词最前追加指令（不修改输入框原文）。 */
export const applySubtitleDirectiveToPrompt = (
  userPrompt: string,
  subtitleEnabled: boolean,
): string => {
  const prefix = subtitleEnabled ? SUBTITLE_PROMPT_NEED : SUBTITLE_PROMPT_FORBID;
  const trimmed = userPrompt.trim();
  if (!trimmed) return prefix;
  return `${prefix}\n${trimmed}`;
};
